import { RouterStore } from "mobx-react-router"

const routerStore = new RouterStore()
export default routerStore
